export const PARAM_KEYS = {
  COMPANY_IDENTIFICATION_NUMBER: 'companyIdentificationNumber',
  COMPANY_LEGAL_NAME_KANA: 'kanaLegalCompanyName',
  COMPANY_LEGAL_NAME_LATIN: 'latinLegalCompanyName',
  LEGAL_COMPANY_NAME: 'legalCompanyName',
  ORGANIZATION_TYPE: 'organizationType',
  SECONDHAND_DEALER_NUMBER: 'secondhandDealerNumber',
  SECONDHAND_DEALER_NUMBER_ISSUING_PREFECTURE:
    'secondhandDealerNumberIssuingPrefecture',
  VAT_NUMBER: 'vatNumber',
} as const
